import { Burying, BuryingOptions, SDK_APP_ID, SDK_APP_KEY } from "@/utils/Burying";
import router from "@/router";

const VISIT_ID_KEY = "PC_MARKETING_VISIT_ID";
const VISIT_ACTIVE_KEY = "PC_MARKETING_VISIT_ACTIVE";
const VISIT_TIMEOUT_MS = 30 * 60 * 1000;

export const collectSdkObj = {
  1: "pc_marketing_landing_page_view",
  2: "User_downloads",
};

function getDeviceType(): string {
  const ua = navigator.userAgent;
  if (/iPhone|iPod|iPad/i.test(ua)) return "iOS";
  if (/Android/i.test(ua)) return "android";
  return "PC";
}

function getBuryingOptions(): BuryingOptions {
  return {
    appid: SDK_APP_ID,
    appkey: SDK_APP_KEY,
    channel: "996box_h5",
    deviceType: getDeviceType(),
  };
}

/** 买量埋点（H5 channel / 设备类型，与 996box_h5 页面对齐） */
export function collectSdk(key: keyof typeof collectSdkObj, data?: any) {
  Burying(
    {
      eventname: collectSdkObj[key],
      eventtype: "track",
      properities: {
        ...data,
      },
    },
    getBuryingOptions()
  );
}

function generateVisitId(): string {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

/** visit_id：同 tab 刷新不变；关页重进或超 30 分钟无操作则新建 */
export function getVisitId(): string {
  const now = Date.now();
  let visitId = sessionStorage.getItem(VISIT_ID_KEY);
  const lastActive = sessionStorage.getItem(VISIT_ACTIVE_KEY);
  if (
    !visitId ||
    !lastActive ||
    now - Number(lastActive) > VISIT_TIMEOUT_MS
  ) {
    visitId = generateVisitId();
    sessionStorage.setItem(VISIT_ID_KEY, visitId);
  }
  sessionStorage.setItem(VISIT_ACTIVE_KEY, String(now));
  return visitId;
}

function getQueryValue(key: string): string {
  const value = router.currentRoute.query[key];
  if (Array.isArray(value)) return value[0] || "";
  return value || "";
}

/** 落地页埋点公共字段 */
function getCommonCollectData() {
  return {
    game_id: getQueryValue("id") || getQueryValue("game_id") || 0,
    ttsq_type: getQueryValue("channel_type") || "",
    page_url: window.location.href,
    visit_id: getVisitId(),
  };
}

/** 用户进入买量落地页 */
export function collectPageView() {
  collectSdk(1, getCommonCollectData());
}

export type DownloadType = "PC" | "APP";

/** AI推广-用户点击下载（download_type 仅 PC / APP） */
export function collectDownload(downloadType: DownloadType) {
  collectSdk(2, {
    ...getCommonCollectData(),
    download_type: downloadType,
  });
}

// pc_marketing_landing_page_view  用户进入买量落地页
// User_downloads                  AI推广-用户点击下载（download_type）
